export default __webpack_public_path__ + "static/media/vip_locations_icons_corporate_factory.8aeb0bcf.svg";